// extracted by mini-css-extract-plugin
module.exports = {"header":"unauthenticated-layout_header__FFDuv","logo":"unauthenticated-layout_logo__Yx7lC","landing-content":"unauthenticated-layout_landing-content__6djMq"};